$(document).ready(function () {
  // Écoute des clics sur tous les éléments ayant l'attribut 'data-url_target'
  $("[data-url_target]").click(function (e) {
    e.stopPropagation();
    var url = $(this).data("url_target");
    window.location.href = url;
    return false;
  });

  // Gestion des images sur le menu
  $("header-menu *[data-image-related]").hover(function (e) {
    var target_handle = $(this).data("image-related");
    var $target = $('*[data-link-related="' + target_handle + '"]');

    if ($target.length > 0) {
      $("header-menu *[data-link-related]").not($target.get(0)).hide();
      $target.show();
    } else {
      // On affiche la première image
      $("header-menu *[data-link-related]").hide();
      $("header-menu *[data-link-related]").eq(0).show();
    }
  });

  // *** COLLECTION *** //

  // Toggle management of the bottom seo content on collection page
  $(".toggle_collection_seo_content").click(function () {
    if ($(".collection-seo-content").hasClass("reduced_view")) {
      $(".collection-seo-content").removeClass("reduced_view");
      $(".toggle_collection_seo_content").text($(this).data("see-less"));
    } else {
      $(".collection-seo-content").addClass("reduced_view");
      $(".toggle_collection_seo_content").text($(this).data("see-more"));
    }
  });

  // *** END COLLECTION *** //

  // *** PRODUCT CARD *** //
  $(".card_associated_products span").hover(
    function (e) {
      var image = $(this).data("featured_image");
      var imgElement = $("<img>", { src: image, class: "alternative-img", loading: "lazy" });
      var mediaContainer = $(this).closest(".card").find(".card__media .media");
      mediaContainer.children().length >= 1 ? mediaContainer.children().eq(0).after(imgElement) : mediaContainer.prepend(imgElement);
    },
    function () {
      $(this)
        .closest(".card")
        .find(".card__media .media .alternative-img")
        .fadeOut(100, function () {
          $(this).remove();
        });
    }
  );

  // Gestion de la zone de hover
  // On écoute l'emplacement du curseur au sein du div .card__media
  // Si le curseur est dans le premier tiers de la largeur de l'image, on console log "left"
  // Si le curseur est dans le dernier tiers de la largeur de l'image, on console log "right"
  // Si le curseur est dans le deuxième tiers de la largeur de l'image, on console log "center"
  // si le curseur est plus bas que le div .card__media, on console log "bottom"
  /* $(".product-card-wrapper").mousemove(function (e) {
    var $media = $(this).find(".card__media");
    var mediaWidth = $media.width();
    var mediaHeight = $media.height();
    var mediaOffset = $media.offset();
    var cursorX = e.pageX - mediaOffset.left;
    var cursorY = e.pageY - mediaOffset.top;

    if (cursorY > mediaHeight || cursorX < mediaWidth / 3) {
      // On affiche la première image présente dans le div .card__media .media en lui placant la classe .active, et en retirant cette classe aux autres images
      $media.find(".media img").eq(0).addClass("active").siblings().removeClass("active");
    } else if (cursorX > (mediaWidth * 2) / 3) {
      $media.find(".media img").eq(2).addClass("active").siblings().removeClass("active");
    } else {
      $media.find(".media img").eq(1).addClass("active").siblings().removeClass("active");
    }
  });

  // Quand le focus quitte le .product-card-wrapper, on retire la classe .active de toutes les images et on place la classe .active sur la première image
  $(".product-card-wrapper").mouseleave(function () {
    $(this).find(".card__media .media img").removeClass("active").eq(0).addClass("active");
  }); */

  // FAQ
  $(".faq_nav span").click(function (e) {
    var target = $(this).data("target");

    if ($("." + target).length > 0 && $("." + target).is(":hidden")) {
      $(".faq_nav span").not(this).removeClass("active");
      $(this).addClass("active");
      $(".faq_items:visible").fadeOut(100, function () {
        $("." + target).fadeIn(100);
      });
    }
  });

  // *** Notifications *** //
  // Apparition des notifications
  $(".header_notifications_control").click(function () {
    var $target = $(".header_notifications");

    if ($target.is(":visible")) {
      $target.fadeOut(100);
      return;
    }

    $(".header_notifications").fadeIn(100);
  });

  // Disparition des notifications
  // Si on click en dehors de la zone des notifications
  // Et qu'on a pas cliqué sur le bouton de contrôle
  $(document).click(function (e) {
    if (!$(e.target).closest(".header_notifications").length && !$(e.target).closest(".header_notifications_control").length) {
      $(".header_notifications").fadeOut(100);
    }
  });

  // Au clic sur une notification (.header_notifications_item), on inscrit dans le local storage que la notification a été vue
  $(".header_notifications_item").click(function () {
    var id = $(this).data("id");
    var notifications = JSON.parse(localStorage.getItem("notifications")) || [];

    if (notifications.indexOf(id) === -1) {
      notifications.push(id);
      localStorage.setItem("notifications", JSON.stringify(notifications));
    }
  });

  // Récupération du nombre de notifications non vues
  var notificationsCount = $(".header_notifications_item").length;
  var notifications = JSON.parse(localStorage.getItem("notifications")) || [];
  var notificationsSeen = notifications.length;
  var notificationsUnseen = notificationsCount - notificationsSeen;

  // On met à jour le compteur de notifications (.header_notifications_count)
  $(".header_notifications_count")
    .text(notificationsUnseen)
    .css("opacity", notificationsUnseen > 0 ? 1 : 0);

  // on cache les notifications déjà vues
  notifications.forEach(function (id) {
    $(".header_notifications_item[data-id=" + id + "]").css("opacity", 0.5);
  });

  // Gestion des popins
  $(".popin_overlay").click(function () {
    $("body").removeClass("overflow-hidden");
    $(".popin_wrapper").fadeOut(400, function () {
      // Suppression du contenu de la popin
      $(".popin").remove();
    });
  });

  $(".popin_overlay *")
    .not(".popin_close")
    .click(function (e) {
      e.stopPropagation();
    });

  $(document).on("click", ".popin_close", function (e) {
    $(".popin_overlay").click();
  });

  // Click sur les liens concernés par la popin
  $("[data-popin=1]").click(function (e) {
    e.stopPropagation();
    e.preventDefault();

    // On récupère la section à loader
    var section = $(this).data("target");

    // On fecth le contenu de la section
    $.get("/?section_id=" + section, function (data) {
      // On crée la popin
      var html = data;

      // On prepend et on affiche la zone .popin_wrapper avec le contenu de la popin
      $("body").addClass("overflow-hidden");
      $(".popin_wrapper > div").prepend(html);
      $(".popin_wrapper").fadeIn(400);
    });
  });

  // Gestion de la position du menu en fonction de la barre d'annonce
  if ($(".utility-bar").length) {
    $(".section-header").addClass("with_annoucement_bar");
  }
});
